import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { checkPermission } from "../../../../utils/app.utils";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { BannerApi, bannerList } from "../../../../api/banner/banner.api";
import SwitchCustom from "../../../../components/switch/SwitchCustom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import moment from "moment";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
// import { RoutePath } from "../../../routes/Routes";
import { RootState } from "../../../../store/store";
import { dateTimeToView } from "../../../../utils/date.utils";
import { BANNER_GROUP } from "./enum/enum";
import { STATUS_DATA } from "../../../../constants/enum";
import { routeName } from "../../../../routes/routeName";
import { useTranslation } from "react-i18next";

export const ManageState = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const navigate = useNavigate();



    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_BANNER_SLIDE', permission);

    const [searchParams] = useSearchParams();

    const group_type = searchParams.get('group_type');


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("seq");
    const [sortType, setSortType] = useState<string>("ASC")
    const [search, setSearch] = useState<string>("");
    const [startDate, setStartDate] = useState<string | null>("");
    const [data, setData] = useState<any[]>([]);
    const [endDate, setEndDate] = useState<string | null>("");

    const [id_information_source, set_id_information_source] = useState<any>(null);

    const headCell = [
        {
            id: "seq", width: 50, sortable: true, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "2", disablePadding: false, width: 200, sortable: false, align: "left", label: t("ชื่อ")
        },
        {
            id: "4", disablePadding: false, width: 90, sortable: false, align: "center", label: t("สถานะ")
        },
        {
            id: "5", disablePadding: false, width: 100, sortable: false, align: "center", label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "6", disablePadding: false, width: 100, sortable: false, align: "center", label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", class: matches && data.length > 0, width: 80, label: ""
        },
    ];


    const handleChangeDateRange = (st_date: string | null, end_date: string | null) => {
        setStartDate(st_date)
        setEndDate(end_date)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            modified_date,
            // modified_by,
            // seq,
            banner_name,
            // banner_alert_source,
            status,
            // is_public,
            id_banner,
            row_num,
            create_name,
            modified_name
        } =
            objData;


        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: row_num || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: banner_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <span className="flex justify-center pl-5 items-center">
                        <SwitchCustom checked={status === STATUS_DATA.ACTIVE} onChange={(st) => handleUpdateStatus(id_banner, st ? STATUS_DATA.ACTIVE : STATUS_DATA.INACTIVE)} />
                    </span>
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_name || create_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component:
                        <div className="flex justify-center items-center">
                            <OptionsButtonCustom
                                enableView={checkPermit.isView}
                                enableEdit={checkPermit.isUpdate}
                                enableDelete={checkPermit.isDelete}
                                onDeleteClick={() => handleDeleteBanner(id_banner)}
                                onViewClick={() => navigate({
                                    pathname: routeName.cms_website.website_structure_banner_slide_view.replace(":id", id_banner),
                                    search: createSearchParams({
                                        group_type: group_type ?? ""
                                    }).toString()
                                })}
                                onEditClick={() => navigate({
                                    pathname: routeName.cms_website.website_structure_banner_slide_detail.replace(":id", id_banner),
                                    search: createSearchParams({
                                        group_type: group_type ?? ""
                                    }).toString()
                                })}
                            />
                        </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteBanner = (id_banner: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await BannerApi.updateStatus(id_banner, { status: STATUS_DATA.DELETE }).then((res) => {
                if (res.status < 300) {
                    if (group_type) {
                        handleGetData(group_type);
                    }
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อย"))
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบรายการ"), t("ลบรายการ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleUpdateStatus = async (id_banner: number, status: string) => {
        await BannerApi.updateStatus(id_banner, {
            status
        }).then((res) => {
            if (res.status < 300) {
                if (group_type) {
                    handleGetData(group_type);
                }
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("อัพเดตสถานะไม่สำเร็จ"), err?.response?.data?.message || "")
        })
    }



    const handleGetData = useCallback(async (banner_group: string) => {
        let query: bannerList = {
            page,
            limit: pageLimit,
            sortBy,
            sortType,
            banner_group: banner_group
        }
        if (search) query = { ...query, keyword: search }
        if (startDate && endDate) query = {
            ...query,
            end_date: moment(endDate).format("YYYY-MM-DD"),
            start_date: moment(startDate).format("YYYY-MM-DD"),
        }
        dispatch(setLoading());
        await BannerApi.getList(query).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data?.items || []
                setData(data)
                setTotalItems(res.data.data?.meta?.totalItems || 0);
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, startDate, search, id_information_source, endDate])


    const isBannerGroupKey = (key: string): key is keyof typeof BANNER_GROUP => {
        return key in BANNER_GROUP;
    };
    useEffect(() => {
        if (!group_type || !isBannerGroupKey(group_type)) {
            navigate(routeName.cms_website.website_structure_banner_slide_list);
        }
    }, [group_type, navigate]);

    useEffect(() => {
        if (group_type) {
            handleGetData(group_type);
        }
    }, [handleGetData])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        id_information_source,
        set_id_information_source,
        checkPermit,
        group_type
    }
}